<template>
  <span v-show="false"></span>
</template>
<script>
import store from '../store'

export default {
  name: 'LiveProductData',
  props: ['liveData'],
  data () {
    return {
      version: '0.0.2'
    }
  },
  created () {
    this.parseDataToStore()
  },
  methods: {
    parseDataToStore () {
      store.dispatch('setLiveProductData', this.liveData)
    }
  }
}
</script>
